import axios from 'axios'

const service = axios.create({
    baseURL: "https://daily-api-v2.aplus.gold",
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 2 * 60 * 1000 // request timeout
})

export default service